/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiTabElementType;
(function (ApiTabElementType) {
    ApiTabElementType["UNSPECIFIED"] = "ELEMENT_TYPE_UNSPECIFIED";
    ApiTabElementType["BLOCK"] = "ELEMENT_TYPE_BLOCK";
    ApiTabElementType["CHART"] = "ELEMENT_TYPE_CHART";
    ApiTabElementType["STAT"] = "ELEMENT_TYPE_STAT";
})(ApiTabElementType || (ApiTabElementType = {}));
export function ApiTabElementTypeFromJSON(json) {
    return ApiTabElementTypeFromJSONTyped(json, false);
}
export function ApiTabElementTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiTabElementTypeToJSON(value) {
    return value;
}
